import React, { useState } from "react";
import Logo from "../../components/Logo";

const LoginScreen = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // 'idle' | 'loading' | 'error'
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError(null);

    try {
      const res = await fetch("/api/authenticateUser", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok && data.valid) {
        onSuccess(data);
      } else {
        setError("Access denied. This account does not have permission.");
        setStatus("error");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
      setStatus("error");
    }
  };

  return (
    <div className="tw-relative tw-h-screen tw-overflow-hidden">
      <video
        className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-object-cover tw-z-[-1]"
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src="https://drhyman.com/cdn/shop/videos/c/vp/1803fb0b01b2429dbbfbc8dd38d7a0a6/1803fb0b01b2429dbbfbc8dd38d7a0a6.HD-720p-4.5Mbps-31472086.mp4"
          type="video/mp4"
        />
      </video>

      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-bg-black/60 tw-backdrop-blur-md">
        <div className="tw-px-4 tw-w-full">
          <div className="tw-mx-auto tw-p-6 tw-bg-white tw-rounded-2xl tw-bg-white/80 tw-backdrop-blur-md tw-w-full tw-max-w-lg">
            <form onSubmit={handleSubmit} className="">
              <Logo className="tw-w-full tw-p-8 tw-w-auto" />
              <p className="tw-text-center tw-mb-4">
                Please use the same email you joined the Hyman Hive with <br />{" "}
                — no password needed.
              </p>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="tw-w-full tw-border tw-rounded-full tw-p-4 tw-mb-4"
                placeholder="you@example.com"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="tw-w-full tw-bg-black tw-text-white tw-py-4 tw-rounded-full hover:tw-opacity-80"
              >
                {status === "loading" ? "Checking..." : "Continue"}
              </button>
              {error && (
                <p className="tw-text-red-600 tw-mt-4 tw-text-sm tw-text-center">
                  {error}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
